// extracted by mini-css-extract-plugin
module.exports = {"saveConfirm":"SaveConfirm_saveConfirm__37oKW","saveConfirmIcon":"SaveConfirm_saveConfirmIcon__3GmWD","fadeIn":"SaveConfirm_fadeIn__3-D71"};